import { useDeleteOne, useGetOne, useUpdateOne } from '@/queries/admin';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, FormData } from './Form';
import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import toast from 'react-hot-toast';
import { ROUTES } from '@/config/routes';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: applicationLink } = useGetOne('application-links', id!);
  const { mutateAsync: updateApplicationLink } = useUpdateOne('application-links');
  const { mutateAsync: deleteApplicationLink } = useDeleteOne('application-links');

  const [formData, setFormData] = useState<Partial<FormData> | null>(null);

  useEffect(() => {
    if (!applicationLink) return;
    setFormData({ ...formData, ...applicationLink });
  }, [applicationLink]);

  const onSubmit = async (data: FormData) => {
    try {
      await updateApplicationLink({ id: id!, data });
      toast.success('Ссылка успешно обновлена');
      navigate(ROUTES.ADMIN.APPLICATION_LINKS);
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Произошла ошибка при обновлении ссылки');
    }
  };

  const handleDelete = async () => {
    try {
      await deleteApplicationLink({ id: id! });
      toast.success('Ссылка успешно удалена');
      navigate(ROUTES.ADMIN.APPLICATION_LINKS);
    } catch (error) {
      console.error('Error deleting:', error);
      toast.error('Произошла ошибка при удалении ссылки');
    }
  };

  if (!formData) return <LoadingSpinner className="mt-6" text="Загрузка..." />;

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Ссылки на документы',
          href: ROUTES.ADMIN.APPLICATION_LINKS,
        },
        {
          label: 'Редактирование',
          href: '',
        },
      ]}
    >
      <Form onDelete={handleDelete} onSubmit={onSubmit} formData={formData} />
    </PageLayout>
  );
};
